import { render, staticRenderFns } from "./ModalAddCampaignQuestion.vue?vue&type=template&id=0ecb7cb8&scoped=true"
import script from "./ModalAddCampaignQuestion.vue?vue&type=script&lang=js"
export * from "./ModalAddCampaignQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCampaignQuestion.vue?vue&type=style&index=0&id=0ecb7cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb7cb8",
  null
  
)

export default component.exports